import { useDialogTitleAction } from "./useDialogTitleAction.ts";

/**
 * The left-hand list of named items shared by every `useNamedCollection.ts`-
 * backed editor. The add button itself doesn't render here — see
 * `useDialogTitleAction` for why it reports up to the dialog's title row
 * instead.
 */
export function NamedCollectionList<T extends { name: string }>({
  items,
  selectedName,
  onSelect,
  onAdd,
  addLabel,
}: {
  items: readonly T[];
  selectedName: string | null;
  onSelect: (name: string) => void;
  onAdd: () => void;
  addLabel: string;
}) {
  useDialogTitleAction({ label: addLabel, onAdd });
  return (
    <div className="named-collection-list">
      {items.map((item) => (
        <button
          key={item.name}
          className={
            item.name === selectedName
              ? "button named-collection-list-item tab-active"
              : "button named-collection-list-item"
          }
          aria-pressed={item.name === selectedName}
          onClick={() => onSelect(item.name)}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
}
